"use strict";

module.exports = function ($stateProvider) {
  $stateProvider.state("dashboard.integrations", {
    url: "/integrations",
    templateUrl: "dashboard-integrations/dashboard-integrations.html",
    controller: "dashboardIntegrationsCtrl as ctrl",
    cache: false,
    resolve: {
      integrations: [
        "Integration",
        function (Integration) {
          return Integration.find({
            filter: {
              include: ["client","department"],
            },
          })
            .$promise.then(function (integrations) {
              return integrations;
            })
            .catch(function (error) {
              return error;
            });
        },
      ],
      clients: [
        "Client","Authentication",
        function (Client,Authentication) {
          return Client.find({
            filter: {
              where: { isOU: true },
              include: ["owners"],
            },
          }).$promise.then(function (clients) {
            if(clients.length==0)
              return null;
            if(Authentication.isAuthorized(['admin']))
              return clients;            
            return clients.filter(clt=>clt.owners.find((owner) => owner.id == Authentication.currentUser()));
          });
        },
      ],
      members: [
        "Member",
        function (Member) {
          return Member.find({
            filter: {
              fields: ["id", "email", "firstName", "lastName"],
            },
          }).$promise.then(function (members) {
            return members || [];
          });
        },
      ],
    },
    data: {
      authorizedRoles: ["admin", "owner", "fieldAdmin"],
    },
  });
};
